import type { PayloadAction } from '@reduxjs/toolkit';

import { createSlice } from '@reduxjs/toolkit';

import type { Expense } from '../../types/types';

interface AppState {
  expenses: Expense[];
}

// Define the initial state using that type
const initialState: AppState = {
  expenses: [],
};
export const ProductSlice = createSlice({
  name: 'expenses',
  initialState,
  reducers: {
    setAllExpenses: (state, action: PayloadAction<Expense[]>) => {
      state.expenses = action.payload;
    },
    addExpense: (state, action: PayloadAction<Expense>) => {
      state.expenses = [...state.expenses, action.payload];
    },
  },
});

export const { setAllExpenses, addExpense } = ProductSlice.actions;

export default ProductSlice.reducer;
